import axios from "axios";
import { getApiBaseUrl } from "../../config";

const apiPrefix = getApiBaseUrl("auth");

export const getCategoryData = async (req_body, authtoken) => {
  return await axios.post(`${apiPrefix}/api/v1/categories-list`, req_body, {
    headers: {
      Authorization: `Bearer ${authtoken}`,
    },
  });
};
